import type { FetchTruckClassesQuery } from '@/features/truck-classes/api'
import type { TruckClassesSearch } from '@/routes/_protected/$tenantKey/settings/_system-master-settings/truck-classes/-models'

export function buildFetchTruckClassesQuery(
  tenantKey: string,
  deps: TruckClassesSearch
): FetchTruckClassesQuery {
  return {
    tenantKey,
    query: {
      ...deps,
      enable: deps.enable ?? undefined
    }
  }
}
